import { transparencyColors } from '@Components/BigBrowse/GridCardMesh/gridCardConstants';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { useBbContentPresenter } from '@Components/BigBrowse/bb2/BbContentPresenter';
import { observer } from 'mobx-react-lite';

import type { GridCardMeshProps } from '../GridCardMesh2';
import { ProductCardRounded } from '../primitives/ProductCardRounded';

export const ShopProductCard = observer(function ShopProductCard({
  item,
  onClick,
}: GridCardMeshProps<PlaneTypes.Card_ShopFloor_Product>) {
  const { heroesLoaded } = useBbContentPresenter();
  const parentKey = item.parentHero?.key;

  // Wait for hero to load before rendering the actual product
  if (!heroesLoaded.has(parentKey!)) {
    return null;
  }

  return (
    <ProductCardRounded
      uniqueKey={item.key!}
      position={item.worldPosition}
      size={item.size.width}
      imageUrl={item.data?.imageUrl}
      transparencyColor={transparencyColors[item.type]}
      onClick={onClick}
      useCache
    />
  );
});
